import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import EnvVars from '../declarations/major/EnvVars';
import Client from '../utils/network';
import discordSdk from '../utils/discordSdk';
import { useDispatch } from 'react-redux';
import { setAuth, setIds } from '../reducers/auth/authReducerActions';

export default function Login(): JSX.Element {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [failed, setFailed] = useState(false);

    async function setupDiscordSdk() {
        if (!discordSdk) {
            setFailed(true);
            return;
        }
        try {
            await discordSdk.ready();
            // Authorize with Discord Client
            const { code } = await discordSdk.commands.authorize({
                client_id: EnvVars.discordClientId,
                response_type: "code",
                state: "",
                prompt: "none",
                scope: ["identify", "guilds"],
            });
            await Client.request(`/api/login?code=${code}`, {
                method: 'GET',
            });

            dispatch(setAuth(true));
            dispatch(setIds(discordSdk.channelId as string, discordSdk.guildId as string));
            navigate('/main');
        } catch {
            setFailed(true);
        }
    }

    useEffect(() => {
        setupDiscordSdk();
    }, []);

    return (
        <header className="App-header">
            <h1>
                Pineapple VTT <small>(tm pending)</small>
            </h1>
            {failed && (
                <>
                    {EnvVars.serverAddress !== undefined
                        ? (
                            <a
                                type='button'
                                className="dndbtn login-btn"
                                href={`${EnvVars.serverAddress}/`
                                    + "authorize?redirect_uri="
                                    + `${encodeURIComponent(`${window.location.origin}/redirect`)}`}
                            >
                                LOGIN
                            </a>
                        )
                        : (
                            <h1 className='dndbtn'>Sorry The service is currently unavailable</h1>
                        )}
                </>
            )}
        </header>
    );
}
